package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val BlogCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .overflow(Overflow.Hidden)
            .boxShadow(
                offsetX = 0.px, offsetY = 4.px, blurRadius = 12.px,
                color = Color.rgba(0, 0, 0, 0.1f)
            )
            .transition(
                Transition.of(
                    property = "all",
                    duration = 400.ms,
                    timingFunction = TransitionTimingFunction.cubicBezier(0.22, 1.0, 0.36, 1.0)
                )
            )
    }

    hover {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                offsetX = 0.px, offsetY = 12.px, blurRadius = 24.px,
                color = Color.rgba(15, 23, 42, 0.12f)
            )
    }

    focusVisible {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                offsetX = 0.px, offsetY = 12.px, blurRadius = 24.px,
                color = Color.rgba(15, 23, 42, 0.12f)
            )
            .outline(2.px, LineStyle.Solid, HLDITheme.Colors.accent)
    }
}